module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAAAAXNSR0IArs4c6QAAAFBJREFUOE9j/P//fzIDA4MMA3ngCeP///+vMzAwSJCnn+EJI5ka4dqGgwH///+fz8DAoEBmWNwBxcJ0CmLhwXAIRDIDD5GQ/v//f5mCvPACAD6yFzYB2IK/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/Vector.png
// module id = Vxsl
// module chunks = 74